import React from 'react';
import { useTranslation } from 'react-i18next';
import VotingResult from '../../common/VotingResult';
import Card from '../../common/Card/Card';
import ChevronLink from '../../common/ChevronLink/ChevronLink';
import './VotingDataCard.css';
import IconText from '../../common/IconText/IconText';
import { Colors } from '../../../Constants';
import './VotingUnityCard.css';
import { VotingUnityCardDataType } from '../../../types';

type Props = {
    data: VotingUnityCardDataType;
};

export const VotingUnityCard = ({ data }: Props) => {
    const { t } = useTranslation();
    const { id_hlasovani, ano, ne, zdrzel_se, cislo_hlasovani, predmet_hlasovani, vysledek, vote_match } = data;

    const renderVotingResults = (isMobile: boolean) => {
        return (
            <div className={`voting-unity-voting-results${isMobile ? ' for-mobile' : ' for-desktop'}`}>
                {ano > 0 && (
                    <IconText
                        icon='check_box'
                        text={ano?.toString()}
                        iconAndHighlightColor={Colors.success}
                        highlightSubString={ano?.toString()}
                        className={isMobile ? 'mobile-result' : ''}
                    />
                )}
                {ne > 0 && (
                    <IconText
                        icon='disabled_by_default'
                        text={ne?.toString()}
                        iconAndHighlightColor={Colors.error}
                        highlightSubString={ne?.toString()}
                        className={isMobile ? 'mobile-result' : ''}
                    />
                )}
                {zdrzel_se > 0 && (
                    <IconText
                        icon='indeterminate_check_box'
                        text={zdrzel_se?.toString()}
                        iconAndHighlightColor={Colors.darkGray}
                        highlightSubString={zdrzel_se?.toString()}
                        className={isMobile ? 'mobile-result' : ''}
                    />
                )}
            </div>
        );
    };

    return (
        <>
            <Card className='voting-card voting-unity-card'>
                <div className='data-card-header'>
                    <div>
                        {/* Currently missing in the response */}
                        {/* <h6>{cislo_zasedani}</h6> */}
                        <h6>{`${t('no.')} ${cislo_hlasovani}`}</h6>
                        <VotingResult voteResult={vysledek === 'přijato' ? true : false} />
                    </div>
                    {renderVotingResults(false)}
                    <h6>{`${t('agreement', { ns: 'analyses' })} ${vote_match}`}</h6>
                </div>
                <div className='data-card-body clipped-text'>
                    <p>{predmet_hlasovani}</p>
                    <div className='voting-unity-voting-results-mobile-wrapper for-mobile'>
                        {renderVotingResults(true)}
                        <ChevronLink
                            chevronDirection='right'
                            text={t('voting-detail')}
                            linkUrl={`${id_hlasovani}`}
                            linkDisabled
                        />
                    </div>
                    <ChevronLink
                        className='for-desktop'
                        chevronDirection='right'
                        text={t('voting-detail')}
                        linkUrl={`${id_hlasovani}`}
                        linkDisabled
                    />
                </div>
            </Card>
        </>
    );
};
